<template>
  <div class="main">
    <Header
      :show="true"
      title="申请开罐"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
    <van-notice-bar
      wrapable
      :scrollable="false"
      text="请仔细检测核对后再进行提交"
      />
      <van-form
        ref="create"
        @submit="submit"
      >
        <van-field
        v-model.trim="listQuery.plateNumber"
        label="车牌号"
        placeholder="请输入正确车牌号码"
        required
        :rules="[{ validator: validPlateNumber, message: '' }]"
      />
      <van-field
        clickable
        name="picker"
        :value="listQuery.material"
        label="物料名称"
        placeholder="点击选择物料名称"
        required
        @click="material.show = true"
        :rules="[{ validator: validMaterialName, message: '' }]"
      />
      <van-popup v-model="material.show" position="bottom">
        <van-picker
          show-toolbar
          :columns="material.columns"
          @confirm="handleMaterialSelect"
          @cancel="material.show = false"
        />
      </van-popup>
      <van-field
        v-model.trim="listQuery.supplier"
        label="供应商"
        placeholder="请输入供应商"
        required
        :rules="[{ validator: validSupplierName, message: '' }]"
      />
      <van-field
        name="凭证照片"
        label="凭证照片"
        required
        :rules="[{ validator: validPhoto, message: '请上传照片' }]"
      >
        <template #input>
          <van-uploader
            v-model="listQuery.applyPhoto"
            :max-count="1"
            capture="camera"
            :before-read="beforeRead"
            :after-read="afterRead"
            :before-delete="beforeDelete"
          />
        </template>
      </van-field>
      <van-field
        v-model="listQuery.remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="100"
        placeholder="请输入备注"
        show-word-limit
      />
      <div style="margin: .6rem 1rem;">
        <van-button round block type="info" native-type="submit">
          确定
        </van-button>
        <van-button round block :to="{path:'/dashboard/order', replace: true}" replace style="margin-top: .3rem">
          返回
        </van-button>
      </div>
    </van-form>
    </div>
    <Footer :show="false" value="service" />
  </div>
</template>

<script>
  import * as imageConversion from 'image-conversion'
  import { parseTime } from '@/utils'
  import { Dialog } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { isPlateNumber, isUserName, isPassword, isChinese, isPhone, isEmail } from '@/utils/validate.js'
  import { getList as getMaterialList, createMaterialCheckOne as createOne } from '@/api/material.js'

  export default {
    name: "ServiceBussinessMaterialCreate",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        baseUrl: '',
        isLoading: false,
        listQuery: {
          id: null,
          file: null,
          plateNumber: '',
          material: '',
          supplier: '',
          applyPhoto: [],
          remark: '',
        },
        material: {
          show: false,
          columns: []
        }
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {
      const url = window.location.href
      this.baseUrl = url.substr(0, url.indexOf('/ndwnq')) + '/ndwnq'
      this.handleGetMaterialList()
    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$refs.create.submit()
      },
      submit() {
        let data = new FormData()
        data.append("plateNumber", this.listQuery.plateNumber)
        data.append("materialName", this.listQuery.material)
        data.append("supplierName", this.listQuery.supplier)
        data.append("credentialsImage", this.listQuery.file)
        Dialog.confirm({
          title: '确认提交开罐申请？',
          message: '物料名称：' + this.listQuery.material
        }).then(() => {
          this.loading = true
          createOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true , 'toast', null, 2000, data.code, '开罐申请', data.message)) {
              this.$router.push({ path:'/dashboard/order', replace: true })
            }
            this.loading = false
          }).catch(function(error) {
            this.loading = false
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '开罐申请', '取消')
        })
      },
      beforeRead(file) {
        if (file.type !== 'image/jpeg') {
          showPhoneAlarm(true, 'toast', 'success', 2000, 200, '图片上传', '请上传 jpg 格式图片')
          return false
        }
        return true
      },
      afterRead(file) {
        return new Promise((resolve, reject) => {
          let isLt2M = file.file.size / 1024 / 1024 < 0.2 // 判定图片大小是否小于4MB
          if (isLt2M) {
            this.listQuery.file = file.file
            resolve(file)
          }
          const scale = parseFloat(1/(file.file.size / 1024 / 1024 / 0.2)).toFixed(2)
          imageConversion.compressAccurately(file.file, {
            size: 200,
            // scale: scale,
            width: 640
          }).then(res => {
            this.listQuery.file = res
            resolve(res)
          })
        })
      },
      beforeDelete(file) {
        this.listQuery.file = null
        return true
      },
      handleMaterialSelect(value) {
        this.listQuery.material = value
        this.material.show = false
      },
      handleGetMaterialList() {
        const data = {
          page: 1,
          limit: 10000
        }
        getMaterialList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            const items = data.data.items
            this.material.columns = []
            for (let i=0; i<items.length; i++) {
              if (items[i].type === 2) {
                this.material.columns.push(items[i].name)
              }
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  // 系统样式修改
  ::v-deep .van-field__label {
    width: 5em;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox__icon {
    font-size: 4.5vw;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F8F8F8;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
